import { createTheme } from "@mui/material/styles";
import { hover } from "@testing-library/user-event/dist/hover";

export const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(0, 103, 121, 1)",
      dark: "#323f56",
    },
    secondary: {
      main: "#1C2536",
    },
    error: {
      main: "#ef5350",
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    button: {
      // textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // color: "white",
          fontWeight: 400,
          // height:'45px'
        },
        // contained: {
        //   boxShadow: "0px 10px 30px rgba(18, 183, 106, 0.39)",
        //   '&:hover': {
        //     boxShadow: "0px 10px 30px rgba(18, 183, 106, 0.39)",
        //   },
        // },
        outlined: {
          text: {
            color: "#1C2536",
          },
        },

        text: {
          color: "#3f50b5",
        },
      },
    },
    MuiIconButton: {
      // Use MuiIconButton for styling IconButton
      styleOverrides: {
        root: {
          fontSize: 20,
          color: "rgba(0, 103, 121, 1)",
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontSize: 16,
          color: "#3f50b5",
          "&.Mui-selected": {
            backgroundColor: "rgba(0, 103, 121, 1)",
            color: "white",
          },
          "&:hover": {
            backgroundColor: "rgba(0, 103, 121, 1)",
            color: "white",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": {},
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {},
      },
    },
  },
});
